import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import CloseIcon from '@mui/icons-material/Close'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { showPopup, closePopup } from '../../actions/uiActions'
import { deleteDbJob } from '../../actions/dbFunctionsActions'

function DeleteDbJob(props) {
    function handleClick(event) {
        event.preventDefault()
        props.closePopup()
    }

    function deleteClick(event) {
        event.preventDefault()
        let deleteJobReq = props.deleteDbJob(props.popupInfo.jobId)

        deleteJobReq.then((resp) => { 
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                props.showPopup("infoDbJob", { header: "Delete Job", message: "Delete Job Completed" })
            }
        })
    }

    // This is the render logic, no need to declare another method is a functional component
    return (<Dialog
        open={true}
        onClose={handleClick}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <CloseIcon onClick={handleClick} className="closePoup" />
        <DialogTitle id="alert-dialog-title" className="changepassdialog">
            {'Delete Database Job?'}
            {' '}
        </DialogTitle>
        <DialogContent>
            <div className="passwordResetbox">
                <button
                    className="btn"
                    onClick={deleteClick}>
                        Delete
                </button>
            </div>
        </DialogContent>
    </Dialog>)
}

function mapStateToProps(state) {
    return {
        popupInfo: state.ui.popupInfo
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ showPopup, closePopup, deleteDbJob }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteDbJob)